import React, { useState, useEffect } from "react";
import { Box, Button, Container, Typography, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { apiCall } from "../config/api";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import { Lock as LockIcon } from "@mui/icons-material";

export default function UnauthorizedPage() {
  const [userPins, setUserPins] = useState([]);
  const [loadingPins, setLoadingPins] = useState(true);
  const navigate = useNavigate();
  const { logout, currentUser } = useAuth(); // currentUser'ı al

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error("Logout failed", error);
      // Kullanıcıya bir hata mesajı gösterilebilir
    }
  };

  useEffect(() => {
    const fetchUserPins = async () => {
      if (currentUser) {
        setLoadingPins(true);
        try {
          const response = await apiCall(
            `/api/pins?userId=${currentUser.uid}`,
            "GET"
          );
          if (response.success) {
            setUserPins(response.pins || []);
          } else {
            console.error("Error fetching user pins: ", response.error);
          }
        } catch (error) {
          console.error("Error fetching user pins: ", error);
        } finally {
          setLoadingPins(false);
        }
      }
    };

    fetchUserPins();
  }, [currentUser]);

  return (
    <Container component="main" maxWidth="sm" sx={{ mt: 8 }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <LockIcon sx={{ fontSize: 60, color: "error.main", mb: 2 }} />{" "}
        {/* LockIcon eklendi */}
        <Typography component="h1" variant="h5" gutterBottom>
          Yetkisiz Erişim
        </Typography>
        <Typography variant="body1" align="center" sx={{ mb: 1 }}>
          Bu sayfaya erişim yetkiniz bulunmamaktadır. Lütfen bir yönetici ile
          iletişime geçin veya farklı bir hesapla giriş yapmayı deneyin.
        </Typography>
        {currentUser && (
          <Typography variant="subtitle1" align="center" sx={{ mb: 3 }}>
            Giriş yapan kullanıcı:{" "}
            {currentUser.displayName || currentUser.email}
          </Typography>
        )}
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button variant="contained" onClick={() => navigate("/login")}>
            Giriş Sayfasına Dön
          </Button>
          <Button variant="outlined" onClick={handleLogout}>
            Çıkış Yap
          </Button>
        </Box>
        {currentUser && (
          <Box sx={{ mt: 4, width: "100%" }}>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="h6" gutterBottom align="center">
              Oluşturduğunuz Pinler
            </Typography>
            {loadingPins ? (
              <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
                <CircularProgress />
              </Box>
            ) : userPins.length > 0 ? (
              <List dense>
                {userPins.map((pin) => (
                  <ListItem key={pin.id} divider>
                    <ListItemText
                      primary={pin.title || "Başlıksız Pin"}
                      secondary={`Kategori: ${pin.category || "Belirtilmemiş"}`}
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Typography variant="body2" align="center">
                Henüz oluşturduğunuz bir pin bulunmamaktadır.
              </Typography>
            )}
          </Box>
        )}
      </Paper>
    </Container>
  );
}
